export default "__VITE_ASSET__jh8FHX$E__"